import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const ExportFamiliesMutation = graphql.persisted(
  "ExportFamiliesMutation",
  graphql(`
    mutation ExportFamiliesMutation($input: ExportFamiliesInput!) {
      exportFamilies(input: $input) {
        familyTsv
        childrenTsv
        userErrors {
          message
          path
        }
      }
    }
  `)
);

export { ExportFamiliesMutation };

export function useExportFamilies() {
  return useMutation(ExportFamiliesMutation);
}
